import React from "react";
import LogoHypr from '../../../assets/img/layout/logo_hypr.png'
// Chakra imports
import { Flex, useColorModeValue } from "@chakra-ui/react";

// Custom components
import { HorizonLogo } from "components/icons/Icons";
import { HSeparator } from "components/separator/Separator";

export function SidebarBrand() {
  //   Chakra color mode
  let logoColor = useColorModeValue("navy.700", "white");

  return (
    <Flex align='center' direction='column'>
      <img src={LogoHypr} alt="Logo Hypr" style={{ height: 100, width: 200, objectFit: 'contain' }} />
      <HSeparator mb='20px' />
    </Flex>
  );
}

export default SidebarBrand;
